import { IGirafeContext } from '@geogirafe/lib-geoportal/core';
import ServerCacheManager from '../helpers/servercachemanager';

export default class MapbsContext {
  public readonly serverCacheManager: ServerCacheManager;

  public constructor(context: IGirafeContext) {
    this.serverCacheManager = new ServerCacheManager(context);
  }
}
